<template>
    <el-dialog title="位置" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :append-to-body="true"
               :close-on-press-escape="false" style="position: absolute;top: -70px;">
         <Getpoint   :store_ll='store_ll'></Getpoint>
       
       
         <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>

        </div>


    </el-dialog>
</template>

<script>
    import UserApi from '@/api/user.js';
    import Getpoint from '@/components/map/localPoints.vue';
    export default {
        components: {
            /*图片上传*/
            Getpoint,
        },
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                loading: false,
                dialogVisible: false,
                coordinate:[]
   
            };
        },
        props: ['open_add','store_ll'],
        created() {
            this.dialogVisible = this.open_add;
            
        },
        methods: {


            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })
                }
            }
        }
    }
</script>

<style scoped >
    .draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

</style>



// WEBPACK FOOTER //
// src/components/map/maps.vue